// Captura de foto. En la PWA/app se usa <input> nativo (más simple y confiable
// que getUserMedia). Ver CLAUDE.md §11 y components/PhotoCapture.
import { useCallback } from 'react'

export type PhotoSource = 'camera' | 'gallery'

export function useCamera() {
  // Cámara: una foto. Galería: permite seleccionar VARIAS a la vez.
  const capture = useCallback((source: PhotoSource = 'camera'): Promise<File[]> => {
    return new Promise((resolve) => {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      if (source === 'camera') {
        input.capture = 'environment' // fuerza cámara
      } else {
        input.multiple = true // galería: selección múltiple
      }
      input.onchange = () => resolve(Array.from(input.files ?? []))
      input.click()
    })
  }, [])

  return { capture }
}
